<template>
  <div>
    <div v-if="!loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>
    <template v-if="loadStatus">
      <div class="button-wrapper" v-if="isTeamOwner">
        <button
          class="button-gemnote button-gemnote--small"
          @click="showInviteModal"
        >
          <span>Add user</span>
        </button>
        <button
          class="whitebutton-gemnote whitebutton-gemnote--small"
          @click="showRemoveUserModal"
          :disabled="!usersToRemove.length"
        >
          <span>Remove user</span>
        </button>
      </div>

      <div class="search-region">
        <SearchAndFilter
          placeholder="Search by name or email"
          :showDate="false"
          :hasButton="false"
        />
      </div>

      <RemoveUserModal
        :showFooter="true"
        :modalName="removeUserModalName"
        :buttonLabel="'Remove User'"
        v-show="isModalActive"
        @confirmAction="cofirmRemoveUsers($event)"
        colorVariation="secondary"
      >
        <template slot="header">
          <h4 class="remove-user-header">Remove User</h4>
        </template>
        <template slot="body">
          <p>{{ getUsersListToRemove }}</p>
        </template>
      </RemoveUserModal>

      <InviteModal :showFooter="false" v-if="showModal" colorVariation="coast">
        <template slot="header">
          <h4 class="editorial header">Add User</h4>
        </template>
        <template slot="body">
          <InviteForm :isOnBoardFlow="false" />
        </template>
      </InviteModal>
      <component
        :is="memberListComponent"
        :members="concatArrays(members, invitations)"
        :teamsList="teamsList"
      ></component>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { concat } from 'lodash'
import { progressStatus } from '../../helpers'
import SearchAndFilter from '@/components/Universal/SearchAndFilter'
import InviteForm from '@/components/Members/InviteForm'
import { storeModules } from '../../helpers'

export default {
  name: 'ManageUsers',
  created() {
    this.$store.dispatch('team/loadMembers', {
      page: '',
      perPage: ''
    })
    this.$store.dispatch('team/loadInvitations', {
      page: '',
      perPage: ''
    })
    if (this.isTeamOwner) this.$store.dispatch('subTeams/getTeamsList')
  },
  components: {
    MembersList: () => import('@/components/Members/MembersList'),
    LiteMembersList: () => import('@/components/Members/LiteMembersList'),
    InviteModal: () => import('@/components/Universal/Modal'),
    RemoveUserModal: () => import('@/components/Universal/RemoveModal'),
    Skeleton: () => import('@/components/Universal/Skeleton'),
    SearchAndFilter,
    InviteForm
  },
  data() {
    return {
      serverParams: {
        page: 0,
        perPage: 50
      },
      removeUserModalName: 'removeUserModal'
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadMembers)
    },
    getUsersListToRemove() {
      return `You are about to remove ${this.usersToRemove
        .map(user => user.name)
        .join(', ')} from Users.`
    },
    ...mapState({
      errors: state => state.team.errors,
      loadMembers: state => state.team.loadMembers,
      loadInvitations: state => state.team.loadInvitations,
      members: state => state.team.currentMembersList,
      invitations: state => state.team.currentInvitationsList,
      isTeamOwner() {
        return this.$store.getters['profile/isTeamOwner']
      },
      showModal: state => state.modal.showModal,
      usersToRemove: state => state.team.usersToRemove,
      teamsList: state => state.subTeams.teamsList,
      team: state => state.team.team
    }),
    ...mapGetters({
      activeModals: 'modal/activeModals'
    }),
    user() {
      return this.$store.getters['profile/user']
    },
    memberListComponent() {
      if (
        this.team.teamModuleNames.includes(storeModules.swag_store) ||
        this.team.teamModuleNames.includes(storeModules.e_commerce)
      ) {
        return 'MembersList'
      }

      return 'LiteMembersList'
    },
    isModalActive() {
      return this.activeModals(this.removeUserModalName)
    }
  },
  methods: {
    concatArrays(a, b) {
      return concat(a, b)
    },
    cofirmRemoveUsers() {
      this.$store.dispatch('team/removeUsersFromTeam')
    },
    showRemoveUserModal() {
      if (this.usersToRemove.length) {
        this.$store.dispatch('modal/showRemoveModal', this.removeUserModalName)
      } else {
        this.$store.dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              `There's no selected users to remove from this team. please select at least one.`
            ]
          },
          { root: true }
        )
      }
    },
    showInviteModal() {
      this.$store.dispatch('modal/showModal')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.remove-user-header {
  font-family: $editorial;
  font-weight: normal;
  font-size: 2rem;
}

.header {
  font-family: $editorial;
  font-weight: normal;
  font-size: 2rem;
  color: $pebble;
  margin-bottom: 1.5rem;
}

.button-wrapper {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;

  .button-gemnote,
  .whitebutton-gemnote {
    font-size: 0.813rem;
    height: 2.5rem;
    width: auto;
    padding: 0 1.5rem;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
}

.search-region {
  width: 30%;
}
</style>
